import React, { useEffect, useState } from "react";
import { Col, Container, Form, Pagination, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  DRIVER_PAYOUT,
  GET_DRIVERS_PAYOUT_LIST,
} from "../../../services/ApiCalls";
import { toast } from "react-toastify";
import Table from "../../../components/Common/Table";
import { getColum } from "./columns";
import CustomPagination from "../../../components/Common/CustomPagination";
import PaginationFilter from "../../../components/Common/PaginationFilter";
import Search from "../../../components/Common/Search";
import { useSelector } from "react-redux";

const DriverPayout = () => {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    search: "",
    status: "all",
  });

  // const drivedata = useSelector((s)=>)
  const getData = async (body) => {
    setLoader(true);
    try {
      const res = await GET_DRIVERS_PAYOUT_LIST(body);

      if (res?.data?.status === "success") {
        setData(res.data.data);
        setTotalCount(res.data.totalcount);
        setLoader(false);
      } else {
        toast.error(res?.data?.message);
        setLoader(false);
      }
    } catch (error) {
      toast.error("something went wrong");
      setLoader(false);
    }
  };

  useEffect(() => {
    if (!body.search.trim()) getData(body);
  }, [body.search]);

  useEffect(() => {
    getData(body);
  }, [body.limit]);

  const pageChangeHandler = (page) => {
    const newBody = {
      ...body,
      page,
    };
    setBody(newBody);
    getData(newBody);
  };

  // const id = location.pathname.split("/")[2];
  const payOutHandler = async (item) => {
    console.log(item , "itemdata");
    try {
      const res = await DRIVER_PAYOUT({
        bookingId: item?._id,
        paymentMethod: "wallet",
        driverId: item?.driverId,
      });
      console.log(res , "dpres");
      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        getData(body);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const searchHandler = () => {
    getData(body);
  };

  const col = getColum(body , payOutHandler);

  return (
    <>
      <section className="driverPayout position-relative py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="sectionHeader">
                <h3 className="m-0 fw-sbold themeBlue">Driver Payout</h3>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center gap-10 mb-3 mt-3">
                <div className="left">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                    {/* <li className="d-flex align-items-center">
                      <label
                        htmlFor=""
                        className="form-label m-0 me-1 text-muted"
                      >
                        Filter
                      </label>
                      <Form.Select
                        aria-label="Default select example"
                        className="form-control h-auto fw-sbold text-muted"
                      >
                        <option>All Properties</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </Form.Select>
                    </li> */}
                    {/* <li className="d-flex align-items-center">
                      <label
                        htmlFor=""
                        className="form-label m-0 me-1 text-muted"
                      >
                        Showing
                      </label>
                      <Form.Select
                        aria-label="Default select example"
                        className="form-control h-auto fw-sbold text-muted"
                      >
                        <option>10</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </Form.Select>
                    </li> */}
                    <PaginationFilter body={body} setBody={setBody} />
                    <Search searchHandler={searchHandler} setBody={setBody} />
                  </ul>
                </div>
              </div>
              <div className="table-responsive">
                <Table column={col} loader={loader} data={data} />
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <div className="left"></div>
                  <div className="right">
                    <CustomPagination
                      total={totalCount}
                      current={body.page}
                      pageSize={body.limit}
                      pageChangeHandler={pageChangeHandler}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default DriverPayout;
